import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import en from '@/i18n/locales/en';
import de from '@/i18n/locales/de';
import {readLanguage} from '@/i18n/languageStorage';

export const SUPPORTED_LANGUAGES = [
  {code: 'en', key: 'languages.en'},
  {code: 'de', key: 'languages.de'},
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

i18n.use(initReactI18next).init({
  resources: {
    en: {translation: en},
    de: {translation: de},
  },
  lng: readLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
